import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P00061InstallationFinish } from './P00061/Installation/P00061InstallationFinish';
import { P00061InstallationReset } from './P00061/Installation/P00061InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00061ChauffageMiseEnOeuvreInit } from './P00061/Chauffage/miseenoeuvre/P00061ChauffageMiseEnOeuvreInit';
import { P00061InstallationIdentificationPacComponent } from './P00061/Installation/p00061-installation-identification-pac/p00061-installation-identification-pac.component';
import { P00061InstallationPositionPacComponent } from './P00061/Installation/p00061-installation-position-pac/p00061-installation-position-pac.component';
import { P00061CardChauffageControleComponent } from './P00061/Chauffage/cards/p00061-card-chauffage-controle/p00061-card-chauffage-controle.component';
import { P00061CardChauffageStatutComponent } from './P00061/Chauffage/cards/p00061-card-chauffage-statut/p00061-card-chauffage-statut.component';
import { P00061ChauffageMiseEnOeuvreProgrammationComponent } from './P00061/Chauffage/miseenoeuvre/p00061-chauffage-mise-en-oeuvre-programmation/p00061-chauffage-mise-en-oeuvre-programmation.component';
import { P00061ChauffageMiseEnOeuvreFiltrationComponent } from './P00061/Chauffage/miseenoeuvre/p00061-chauffage-mise-en-oeuvre-filtration/p00061-chauffage-mise-en-oeuvre-filtration.component';
import { P00061ChauffageMiseEnOeuvrePacComponent } from './P00061/Chauffage/miseenoeuvre/p00061-chauffage-mise-en-oeuvre-pac/p00061-chauffage-mise-en-oeuvre-pac.component';
import { P00061ChauffageControleComponent } from './P00061/Chauffage/cps/p00061-chauffage-controle/p00061-chauffage-controle.component';
import { P00061ChauffageParametersComponent } from './P00061/Chauffage/cps/p00061-chauffage-parameters/p00061-chauffage-parameters.component';
import { P00061ChauffageStatutComponent } from './P00061/Chauffage/cps/p00061-chauffage-statut/p00061-chauffage-statut.component';
import { P00043Alarm } from './P00043/Alarm/P00043Alarm';
import { P00061Alarm } from './P00061/Alarm/P00061Alarm';

export class P00061Data {
  wpCModeFonctionnement: number = 0;

  wpCResetUsine: number = 0;

  wpCConfirmationOTA: number = 0;

  wpIActivationFonctionPriorite: number = 0;

  wpIActivationFonctionAutoMaintien: number = 0;

  wpIConfigurationProduit: number = 0;

  wpISourceVolet: number = 0;

  wpPModeFonctionnementTemperature: number = 0;

  wpPTemperatureConsigne: number = 0;

  wpPPlanning1HeureDepart: number = 0;

  wpPPlanning1HeureFin: number = 0;

  wpPPlanning2HeureDepart: number = 0;

  wpPPlanning2HeureFin: number = 0;

  wpPPlanning1DepartPlanning: number = 0;

  wpPPlanning1FinPlanning: number = 0;

  wpPPlanning2DepartPlanning: number = 0;

  wpPPlanning2FinPlanning: number = 0;

  wpPTypeHorloge: number = 0;

  wpPFonctionnementCompresseur: number = 1;

  wpPModeSilence: number = 0;

  wpPHorlogeSemaine: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourLundi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourMardi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourMercredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourJeudi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourVendredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourSamedi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpPHorlogeJourDimanche: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  wpSEtatFonctionnementPAC: number = 0;

  wpSCommandeHorloge: number = 0;

  wpSMiseRouteFiltrationPriorite: number = 0;

  wpSMiseRouteFiltrationAutoMaintien: number = 0;

  wpSEtatVolet: number = 0;

  wpSDIsponibiliteEtatVolet: number = 0;

  wpSRecommandationFermetture: number = 0;

  wpSAlarme: number = 0;

  wpSEtatSysteme: number = 0;

  wpSEtatBouton: number = 0;

  wpSTemperatureConsigneHorloge: number = 0;

  wpSBypassPac: number = 0;

  wpSCompteurResetUsine: number = 0;

  wpSTempsSousTension: number = 0;

  wpSCompteurBouton: number = 0;

  wpSFonctionnementPACCompresseur: number = 0;

  wpSFonctionnementPACVentilationHauteVitesse: number = 0;

  wpSFonctionnementPACVentilationFaibleVitesse: number = 0;

  wpSFonctionnementPACPilotagePompeCirculation: number = 0;

  wpSFonctionnementPACPilotageVanne4Voies: number = 0;

  wpSOnOff: number = 0;

  wpSTemperatureConsigneModeFroid: number = 0;

  wpSTemperatureConsigneModeChaud: number = 0;

  wpSTemperatureConsigneModeAuto: number = 0;

  wpSTemperatureEauEntrante: number = 0;

  wpSTemperatureEauSortante: number = 0;

  wpSTemperatureAmbiante: number = 0;

  wpSTemperatureEntreeEvaporateur: number = 0;

  wpSTemperatureEntreeCompresseur: number = 0;

  wpSTemperatureSortieCompresseur: number = 0;

  wpSPression: number = 0;

  wpSFrequenceCompresseur: number = 0;

  wpSTensionSecteur: number = 0;

  wpSCourantConsomme: number = 0;

  wpSDefautsPrincipauxCodeP01: number = 0;

  wpSDefautsPrincipauxCodeP02: number = 0;

  wpSDefautsPrincipauxCodeP04: number = 0;

  wpSDefautsPrincipauxCodeP05: number = 0;

  wpSDefautsPrincipauxCodeP07: number = 0;

  wpSDefautsPrincipauxCodeP081: number = 0;

  wpSDefautsPrincipauxCodeE051: number = 0;

  wpSDefautsPrincipauxCodeE01: number = 0;

  wpSDefautsPrincipauxCodeE02: number = 0;

  wpSDefautsPrincipauxCodeE03: number = 0;

  wpSDefautsPrincipauxCodeE19: number = 0;

  wpSDefautsPrincipauxCodeE29: number = 0;

  wpSDefautsPrincipauxCodeE07: number = 0;

  wpSDefautsPrincipauxSystem1: number = 0;

  wpSDefautsPrincipauxCodeE06: number = 0;

  wpSDefautsPrincipauxDefrosting: number = 0;

  wpSRegistreDefauts2CompressorOverloadProtection: number = 0;

  wpSRegistreDefauts2HighPressureProtection: number = 0;

  wpSRegistreDefauts2LowPressureProtection: number = 0;

  wpSRegistreDefauts2WaterFlowProtection: number = 0;

  wpSRegistreDefauts2AntifreezingProtection: number = 0;

  wpSRegistreDefauts2HighDischargeTemperatureProtection: number = 0;

  wpSRegistreDefauts2MOPDriveWarning: number = 0;

  wpSRegistreDefauts2ConverterBoardOffline: number = 0;

  wpSRegistreDefauts2IPMProtection: number = 0;

  wpSRegistreDefauts2CompressorStartFailure: number = 0;

  wpSRegistreDefauts2ConverterInputLostPhase: number = 0;

  wpSRegistreDefauts2IPMSamplingCurrentFailure: number = 0;

  wpSRegistreDefauts2ConverterOverheatProtection: number = 0;

  wpSRegistreDefauts2ConverterDCOverVoltage: number = 0;

  wpSRegistreDefauts2ConverterDCUnderVoltage: number = 0;

  wpSRegistreDefauts2InputUnderVoltage: number = 0;

  wpSRegistreDefauts3InputOverVoltage: number = 0;

  wpSRegistreDefauts3SamplingVoltageFailure: number = 0;

  wpSRegistreDefauts3DspPfcConnectionFailure: number = 0;

  wpSRegistreDefauts3RadiatorTemperatureSensingFailure: number = 0;

  wpSRegistreDefauts3OverUnderVoltageFailure: number = 0;

  wpSRegistreDefauts3PfcFailure: number = 0;

  wpSRegistreDefauts3IpmOverheatProtection: number = 0;

  wpSRegistreDefauts3WeakMagneticProtection: number = 0;

  wpSRegistreDefauts3InputOverCurrentWarning: number = 0;

  wpSRegistreDefauts3ConverterOverheatWarning: number = 0;

  wpSRegistreDefauts3InputOvercurrentProtection: number = 0;

  wpSRegistreDefauts3EepromErrorWarning: number = 0;

  wpSRegistreDefauts3IpmProtection: number = 0;

  wpSRegistreDefauts3DCFanMotorDriverBoardProtection: number = 0;

  wpSRegistreDefauts3PressureSensorFailure: number = 0;

  wpSRegistreDefauts3InputCoverCurrent: number = 0;

  wpSRegistreDefauts4AntiFreezingProtection: number = 0;

  wpSRegistreDefauts4AntiFreezingProtectionHeatingMode: number = 0;

  wpSRegistreDefauts4ECFanMotorSignalFailure: number = 0;

  wpSRegistreDefauts4FanMotor1Failure: number = 0;

  wpSRegistreDefauts4FanMotor2Failure: number = 0;

  wpSRegistreDefauts4DCFanMotorCommunicationFailure: number = 0;

  wpSRegistreDefauts4InletOutletTempDifferenceTooMuch: number = 0;

  wpSRegistreDefauts4LowAmibentTempProtection: number = 0;

  wpSRegistreDefauts4CoilTempSensor2Failure: number = 0;

  wpSEtatSwitchsHPSwitch: number = 0;

  wpSEtatSwitchsLPSwitch: number = 0;

  wpSEtatSwitchsWaterFlowSwitch: number = 0;

  wpSEtatSwitchsRemoteOnOff: number = 0;

  wpSEtatSwitchsmodeRemote: number = 0;

  wpSEtatSwitchsMasterAndSlave: number = 0;

  wpSVitesseVentilateurPrincipal: number = 0;

  wpSCompteurPuissanceActiveTotal: number = 0;

  puissanceConsomme: number = 0;
}

export class P00061 extends IProduct {
  override deviceTableIndex: number = 25;

  override modelIdentifier?: string = 'P00061';

  override dataIdentifier?: string = 'P00061';

  override manufacturerName?: string = 'ACWA';

  data: P00061Data = new P00061Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00061/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00061/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00061/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00061;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00061?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00061.tuto.installation.help.title',
      helpSlides: [
        'P00061.tuto.installation.help.1',
        'P00061.tuto.installation.help.2',
        'P00061.tuto.installation.help.3',
        'P00061.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00061/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00061/installation-1_dark.png',
          },
          text: 'P00061.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00061/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00061/installation-2_dark.png',
          },
          text: 'P00061.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00061/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00061/installation-1_dark.png',
          },
          text: 'P00061.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00061/update-2.png',
            dark: '/assets/ecosystem/images/products/P00061/update-2_dark.png',
          },
          text: 'P00061.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00061InstallationIdentificationPacComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00061InstallationPositionPacComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P00061InstallationFinish,
        reset: P00061InstallationReset,
      },

      alarms: {
        weight: 20,
        component: P00061Alarm,
      },

      controlCards: [
        { component: P00061CardChauffageControleComponent, weight: 10 },
      ],

      statusCards: [
        { component: P00061CardChauffageStatutComponent, weight: 20 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.PAC];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.PAC ||
      functionnality == EventProductFunctionnalityEnum.PAC
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00061ChauffageMiseEnOeuvreProgrammationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00061ChauffageMiseEnOeuvreFiltrationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00061ChauffageMiseEnOeuvrePacComponent,
              condition: () => {
                return true;
              },
            },
          ],
          init: P00061ChauffageMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00061ChauffageControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00061ChauffageParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00061ChauffageStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00061.status.pilotagePAC',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 639,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'wpSEtatFonctionnementPAC',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P00061.status.temperatureEau',
                mode: HistoryGraphModeEnum.DATA,
                property: 'wpSTemperatureEauEntrante',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                yModeOptions: { min: -50, max: 400 },
                chartMode: HistoryChartModeEnum.LINEAR,
                showDirectly: false,
              },
              {
                title: 'P00061.status.consigneTemp',
                mode: HistoryGraphModeEnum.DATA,
                property: 'wpSTemperatureConsigneModeChaud',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                yModeOptions: { min: -50, max: 400 },
                chartMode: HistoryChartModeEnum.LINEAR,
                showDirectly: false,
              },
              {
                title: 'P00061.status.tension',
                mode: HistoryGraphModeEnum.DATA,
                property: 'wpSCompteurPuissanceActiveTotal',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 12700 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.PACWP_Controle,
      propertyName: 'wpCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 3;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).wpIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
